import PortfolioGalleryIconContainer from "../../../../components/pages/portfolio/portfolioPage/PortfolioGalleryIcon";

const PortfolioGalleryIcon = () => {
  return <PortfolioGalleryIconContainer />;
};

export default PortfolioGalleryIcon;
